// extracted by mini-css-extract-plugin
export var loadingSpinner = "_2q-0";
export var spinnerContainer = "_2q-1";